import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import OpenInNew from '@material-ui/icons/OpenInNew';

import {
  Button
} from '@material-ui/core';

import {
    currentLanguage,
} from "src/shared_modules/i18n";

import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';

class MarketingConsentButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
          fields: {
          },
          fieldErrors : {
          },
        }
    }

    componentDidMount() {
      this.handleClick= this.handleClick.bind(this);
    }

    handleClick(currentLangi18n) {
      if( this.props.marketingButtonUrl ) {
          //console.log("trackEvent - UserAccount - click - Marketing Button");
          this.props.trackEvent("UserAccount", "click", "Marketing Button");

          //console.log("MarketingConsentButton - handleClick: " + JSON.stringify(this.props.marketingButtonUrl));
          window.open(this.props.marketingButtonUrl[currentLangi18n.code2], "_blank");
      }
    }

    render() {
      let currentLangi18n = currentLanguage();

      if (this.props.showMarketingButton) {
        return <Button
                  color="primary"
                  style={this.props.style}
                  className={this.props.className}
                  startIcon={<OpenInNew />}
                  onClick={() => { this.handleClick(currentLangi18n) }}
                >
                  {this.props.marketingButtonLabel[currentLangi18n.code2]}
                </Button>
      }
      else {
        return null;
      }
    }
}

/*
 * ---------------------------------------------------------------------
 * prop Types
 * ---------------------------------------------------------------------
 */
MarketingConsentButton.propTypes = {
  showMarketingButton: PropTypes.bool,
  marketingButtonUrl: PropTypes.object,
  marketingButtonLabel: PropTypes.object,
};

/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
 const mapStateToProps = ( state, ownProps ) => {
     return {
         showMarketingButton : state.event.showMarketingButton,
         marketingButtonUrl : state.event.marketingButtonUrl,
         marketingButtonLabel : state.event.marketingButtonLabel,
         lang: state.system.currentLang, // must be mapped to trigger the language change for rerendering
     };
 };

const mapDispatchToProps = {

};


/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withMatomo(MarketingConsentButton));
